export default __webpack_public_path__ + "static/media/batteryCell.040cbdac.svg";